
import useCart from '@/composables/useCart'
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const { cartDiscounts, removePromoCode } = useCart()

    return { cartDiscounts, removePromoCode }
  },
})
